module.exports = __webpack_public_path__ + "img/140.f241b871.jpg";